module.exports = __webpack_public_path__ + "media/assets/Ask-4a0a9039df48f64d142cf6be6df7ff1b.svg";